import { useEffect } from "react";

export function useSEO({ title, description, jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) { tag = document.createElement("meta"); tag.name = "description"; document.head.appendChild(tag); }
      tag.content = description;
    }
    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "page-jsonld";
      script.text = JSON.stringify(jsonLd);
      const old = document.getElementById("page-jsonld");
      if (old) old.remove();
      document.head.appendChild(script);
    }
    return () => { if (script) script.remove(); };
  }, [title, description, jsonLd]);
}
